<template>
  <footer>
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-lg-3">
          <h2>Contact Us</h2>T:
          <a href="tel:01502711750">01502 711750</a>
          <br />E:
          <a href="mailto:info@seascaffolding.com">info@seascaffolding.com</a>
          <br />
          <br />
          <p>
            Unit 5b Site 2, Sandpit Lane
            <br />Worlingham, Beccles
            <br />Suffolk, NR32 7TH
          </p>
        </div>
        <div class="col-md-6 col-lg-2">
          <h2>Navigation</h2>
          <ul>
            <li>
              <router-link to="/about-us/">About Us</router-link>
            </li>
            <li>
              <router-link to="/services/">Services</router-link>
            </li>
            <li>
              <router-link to="/past-projects/">Past Projects</router-link>
            </li>
            <li>
              <router-link to="/contact-us/">Contact Us</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6 col-lg-2">
          <h2>Legal</h2>
          <ul>
            <li>
              <router-link to="/terms-of-use/">Terms of Use</router-link>
            </li>
            <li>
              <router-link to="/privacy-and-cookie-policy/">Privacy &amp; Cookie Policy</router-link>
            </li>
          </ul>
        </div>
        <div class="col-md-6 col-lg-5 social">
          <img src="@/assets/images/homePageLogos.png" alt />
          <a href="https://www.facebook.com/sea.scaffolding.75/" target="_blank" rel="nofollow">
            <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'facebook-square' }" />
          </a>
          <a href="https://www.instagram.com/seascaffolding/" target="_blank" rel="nofollow">
            <font-awesome-icon :icon="{ prefix: 'fab', iconName: 'instagram-square' }" />
          </a>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container copyright-container">
        <div class="copyright">
          <span>&copy; Copyright SEA Scaffolding Limited {{copyrightDate}}. All Rights Reserved.</span>
        </div>
        <div class="netmatters-design">
          <p>
            <span>
              <a href="https://www.netmatters.co.uk" target="_blank">Website Designed by Netmatters</a>
            </span>
          </p>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      name: "main-footer",
      copyrightDate: "",
    };
  },
  mounted() {
    this.copyrightDate = new Date().getFullYear();
  },
};
</script>


<style scoped>
.social a {
  font-size: 38px;
  margin-left: 5px;
  transition: color 0.2s ease-in-out;
}
.social a:hover {
  color: #aa0108;
}
</style>



// WEBPACK FOOTER //
// src/components/partials/MainFooter.vue